// The reason recorded when a whole Family A card is marked reviewed — wording
// only, keyed by the card it describes (moved out of ReviewGroupCard.jsx,
// A2-582, so the card itself chooses nothing by a flag's name).
import { bulkAckTotal } from "./reviewCanonical";

const _today = () => new Date().toISOString().slice(0, 10);

export const bulkAckReason = (group, flagTitle) => {
  const date = _today();
  const total = bulkAckTotal(group);
  const count = group.count;
  const rows = count === 1 ? "1 row" : `${count} rows`;
  const noun = count === 1 ? "transaction" : "transactions";
  switch (group.flag_type) {
    case "DATA_PERIOD_NARROWER_THAN_FILING_PERIOD": {
      // A1-105 (operator 2026-11-01): about the whole upload, not the one row
      // that carries the note, so no transaction count or amount
      const n = group.period_note || {};
      const span = n.data_first && n.period_start
        ? ` the upload runs from ${String(n.data_first).slice(0, 10)} to ${String(n.data_last).slice(0, 10)}`
          + ` in a filing period of ${String(n.period_start).slice(0, 10)} to ${String(n.period_end).slice(0, 10)};`
        : "";
      return (
        `Reviewed against source records on ${date};${span} confirmed `
        + `no file is missing and the days outside the data range `
        + `have zero activity; no correction required.`
      );
    }
    case "MISSING_EXCHANGE_RATE":
      return (
        `Reviewed at source on ${date}; ${rows} (${total}) await `
        + `the period exchange rate for ${group.currency}. Rate `
        + `to be entered in Step 2 to resolve all flags at once.`
      );
    case "GB_EU_VAT_CHARGED_ON_EXPORT":
      return (
        `Reviewed at source on ${date}; ${rows} (${total}) flagged `
        + `as GB seller charging EU VAT on export. Confirmed `
        + `seller is registered for the relevant IOSS / EU OSS / `
        + `local EU VAT scheme; sales correctly attributed.`
      );
    default:
      return (
        // v0.6.12 — was `'${group.flag_type}'`, so the audit log read
        // "under 'ART194_LOCAL_REGISTRATION_REQUIRED'". The operator
        // reads and edits this text, and the flag_type is already
        // recorded structurally against the group and its rows, so the
        // prose does not need to carry it too.
        `Reviewed at source on ${date}; ${rows} (${total}) under `
        + `'${flagTitle}' marked acknowledged after source `
        + `review; no correction required.`
      );
  }
};

